import CryptoJS from 'crypto-js';

export function encryptDataForSign({ object, method }) {
  try {
    /** x-ver ios：1、android：2、web：3  h5：4  小程序：5  百度小程序：6  */
    /** x-sn  ios "W/d0d12KjZ4CoMbp" 安卓 "jSxnJyJTKCozsQfL" web "tGHo51QxkM2gE2A5" h5 "aGPy57QxtMqgEsAs" 小程序 "nGKj53QxyMjgEiAu" 百度小程序 "dGfs58QxpMlgEeAo" */
    let key = 'aGPy57QxtMqgEsAs';
    let ver = 4;
    // 时间戳，用作加密 也需要给后端传输
    const timeStamp = new Date().getTime();
    let beforeEncrypt = '';
    let sortObject = {};
    if (object && JSON.stringify(object) !== '{}') {
      // 给对象排序
      sortObject = Object.keys(object)
        .sort()
        .reduce((obj, key) => {
          if (object[key] !== null) obj[key] = object[key];
          return obj;
        }, {});
      if (method === 'post') {
        beforeEncrypt = JSON.stringify(sortObject);
      } else if (method === 'get') {
        beforeEncrypt = Object.keys(sortObject)
          .sort()
          .map(item => `${item}=${encodeURIComponent(sortObject[item])}`)
          .join('&');
      }
    }
    if (beforeEncrypt === '') {
      beforeEncrypt = JSON.stringify(sortObject);
    }

    const TempParams = `${timeStamp}|${method === 'get' ? beforeEncrypt : ''}|${
      method === 'post' ? beforeEncrypt : ''
    }`;

    // 开始加密
    const encryptArr = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(TempParams),
      CryptoJS.enc.Utf8.parse(key),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    // console.log('aes', FormatOpenssl.parse(encryptArr.toString()).ciphertext.toString(Base64));

    const sha256Encrypt = CryptoJS.SHA256(
      CryptoJS.format.OpenSSL.parse(encryptArr.toString()).ciphertext
    );
    // console.log('sha256Encrypt', sha256Encrypt.toString(EncHex));

    return {
      encryptString: sha256Encrypt.toString(CryptoJS.enc.Hex),
      timeStamp,
      sortObject,
      xver: ver
    };
  } catch (error) {
    // console.log('接口验签通用加密方法失败')

    return {
      encryptString: '',
      timeStamp: 0,
      sortObject: object,
      xver: -99
    };
  }
}
